export default __webpack_public_path__ + "static/benefits-benefits-4cd1e2d4c922dce8cb35f4eebacf430b.mp4";